import React from 'react';
export const ProtHeader = () =>
{
    return(<h1 id = "prot_header">Protestation Test</h1>);
} 